import type { ReactNode } from 'react';
import { findGenerativeUiDescriptor } from './registry';
import type { GenerativeUiDeps } from './types';

export type PendingGenerativeUiComponent = { type: string; data: unknown };

/**
 * Renders the composer selector for a pending generative-UI question by dispatching to its
 * registered renderer, or null if the type is unregistered or the payload fails to parse.
 *
 * Mirrors GenerativeUiMessage's registry lookup on the answer side — together these are the
 * only two places in the codebase that call findGenerativeUiDescriptor for rendering.
 *
 * `deps` defaults to empty so a caller that renders no data-backed selector need not supply it.
 */
export function renderGenerativeUiSelector(
    component: PendingGenerativeUiComponent,
    onSubmit: (content: string) => void,
    deps: GenerativeUiDeps = {}
): ReactNode {
    const descriptor = findGenerativeUiDescriptor(component.type);

    if (!descriptor) {
        return null;
    }

    return descriptor.renderSelector(component.data, onSubmit, deps);
}
